import { UiWebHeaderMenuToggleDirective } from './ui-web-header-menu-toggle.directive';

import { Component, Inject, OnDestroy, OnInit, DOCUMENT, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UiServiceEnvironment, UiServiceWebSession } from '@drct-web-apps/ui-services';
import { ReplaySubject, takeUntil } from 'rxjs';



@Component({
  selector: 'ui-web-header',
  templateUrl: './ui-web-header.component.html',
  imports: [ RouterModule, UiWebHeaderMenuToggleDirective ]
})
export class UiWebHeaderComponent implements OnInit, OnDestroy {
  private readonly destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  public readonly env         = inject(UiServiceEnvironment);
  private readonly webSession = inject(UiServiceWebSession);
  private readonly document   = inject(DOCUMENT);

  public enquiry_email = "enquirydrct@gmail.com";
  public topBannerMsg  = "";

  ngOnInit(): void {
    this.setEnquiryEmail();
    this.webSession.sessionReady
                    .pipe(takeUntil(this.destroyed$))
                    .subscribe((ready: boolean) => {
                      if(ready) {
                        this.setEnquiryEmail();
                        this.setTopBannerMsg();
                      }
                    });
  }
  
  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  public closeTopBanner(): void {
    const topBanner = this.document.getElementById('divTopBanner') as HTMLElement;
    if (topBanner) {
      topBanner.classList.add('display--none');
    }
  }

  
  
  private setEnquiryEmail(): void {
    this.enquiry_email = this.webSession.webConfig?.enquiry_email ?? "enquirydrct@gmail.com";
  }

  private setTopBannerMsg(): void {
    this.topBannerMsg = this.webSession.webConfig?.flash_message ?? "";
    if(this.topBannerMsg && this.topBannerMsg.trim().length > 0) {
      const topBanner = this.document.getElementById('divTopBanner') as HTMLElement;
      if (topBanner) {
        topBanner.classList.remove('display--none');
      }
    }
  }
}
